import { Grid, Typography } from '@mui/material';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Screen from '../../components/fragments/Screen';
import CreatePassword from './CreatePassword';
import RequestCode from './RequestCode';

export default function ResetPasswordScreen() {
    const [codeSent, setCodeSent] = useState(false);
    const [phoneNumber, setPhoneNumber] = useState('');

    const navigate = useNavigate();

    return (
        <Screen authPass title="Forgot Password">
            <Grid item xs={12}>
                {!codeSent ? (
                    <RequestCode
                        phoneNumber={phoneNumber}
                        setPhoneNumber={setPhoneNumber}
                        setCodeSent={setCodeSent}
                    />
                ) : (
                    <CreatePassword
                        phoneNumber={phoneNumber}
                        setCodeSent={setCodeSent}
                    />
                )}
                <Typography>Don&apos;t need to reset password? </Typography>
                <Typography onClick={() => navigate(-1)} color="primary">
                    Log In
                </Typography>
            </Grid>
        </Screen>
    );
}
